import { getNextStatus, NOT_FOUND, statusToSkip } from "constants/status-codes";
import { changeStatus } from "./endpoints";
export async function resolveNextValidStatus(workOrderId, currentStatus) {
    const next = getNextStatus(currentStatus);
    if (next === NOT_FOUND)
        throw new Error('No next status code found');
    const { status } = await changeStatus(workOrderId, next);
    return statusToSkip.includes(status)
        ? resolveNextValidStatus(workOrderId, status)
        : status;
}
